import React, {ComponentType} from "react";
import TagIcon from "external-components/tag-icon/index";
import { IProps, IHandlers } from 'external-components/tag-icon/types';

/**
* Gets the interface types as array of strings so we don't need hand code them each time (and reduces chance for mistakes).
*/
import {keys} from 'ts-transformer-keys';
import {hot} from "react-hot-loader";
import {ThemeProvider} from "@material-ui/core/styles";
import ReactUtilsService from "app/services/reactUtils.service";
import RaisedButton from "app/common/raisedButton";

const NS = 'TagIconContainer';

const propsKeys: string[] = keys<IProps>();
const handlersKeys: string[] = keys<IHandlers>();

const ThemeWrap = function(all: IProps & IHandlers) {

  const props: IProps = ReactUtilsService.getObjectByKeys(all, propsKeys) as IProps;

  /**
   * Handlers used to modify app state (via a service) from within the module's container.
   * Similar to redux mapDispatchToProps.
   */
  const handlers: IHandlers = {
  }

  return ReactUtilsService.containerWrap(
    <TagIcon {...props} />
  );
}

/**
 * Returns properties needed for rendering react2angular
 */
export const R2ATagIcon: [ComponentType<unknown>, never[]?, string[]?] = [
  hot(module)(ThemeWrap) as ComponentType<unknown>,
  [...propsKeys, ...handlersKeys] as never[]
];
